/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from "react";
import { FormHelperText } from "@material-ui/core";
import _ from "lodash";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import {
  AsyncCreatableSelect,
  Button,
  EditableText,
  Input,
  MessageHelper,
  Radio,
} from "../../../components/common";
import { rootReducersState } from "../../../reducers";
import {
  userSignUpRequest,
  userSignUpReset,
  companySignUpRequest,
  userSignUpSuccess,
} from "../../../reducers/auth/signUp.reducer";
import appRoutes from "../../../routes/app.routes";
import SelectNew from "../../../components/common/SelectNew";
import useQuery from "../../../hooks/useQuery";
import { ReactComponent as PersonIcon } from "../../../assets/svg/person.svg";
import { ReactComponent as CompanyIcon } from "../../../assets/svg/company-icon.svg";
import { ReactComponent as EnvelopeIcon } from "../../../assets/svg/envelope.svg";
import { ReactComponent as LockIcon } from "../../../assets/svg/lock.svg";
import PhoneIcon from "../../../components/ProfileViewNew/icons/phone-icon.svg";
import Affirmation from "../../../components/common/Affirmation";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import { CUSTOM_GENDER_OPTIONS } from "../../../utils/appConstants";
import { socialLoginErrorMessage, validatePhoneNumber } from "../../../utils/helper";
import companyServices from "../../../services/company.services";
// import FlashMessage from "../../../components/common/FlashMessage";
import httpRequest from "../../../utils/httpRequest";
import API_URLS from "../../../utils/apiUrls";
// import AutoModeIcon from '@material-ui/icons/Loop';
import {
  getAuth,
  signInWithPopup,
  GoogleAuthProvider,
  OAuthProvider,
} from "firebase/auth";
import {
  setCurrentCompanyRequest,
  setSessionTokenRequest,
  setSessionUserRequest,
} from "../../../reducers/auth/session.reducer";
import GoogleSVG from "../../../assets/svg/Googlesvg";
import { Apple } from "@material-ui/icons";

type Inputs = {
  first_name: string;
  last_name: string;
  email: string;
  company_name: string;
  employee_id: string;
  verify_email: string;
  password: string;
  confirm_password: string;
  gender_optional: string;
  termsAndConditions: boolean;
  gender?: string;
  contact_info: string;
};
let searchDelay: any = null;

const SignUp: React.FC = () => {
  // Hooks
  const navigate = useNavigate();
  const query = useQuery();
  const dispatch = useDispatch();
  const userSignUpReducer = useSelector(
    ({ auth }: rootReducersState) => auth.signUp
  );
  // const location = useLocation();
  // const path = location.pathname
  const [genderVal, setGenderVal] = useState<string | null>(null);
  const [disabledReferEmail, setDisabledReferEmail] = useState<boolean>(false);
  const loading = _.get(userSignUpReducer, "loading", false);
  const emailToken = _.get(userSignUpReducer, "token", "");
  const signUpFlag = _.get(userSignUpReducer, "flag");
  const signUpErrors = _.get(userSignUpReducer, "errors", {});
  const signUpErrorMessage = _.get(userSignUpReducer, "message");
  const [signUpState, setSignUpState] = useState("employer");
  const [signUpError, setSignUpError] = useState<string>("");
  const [socialLoading, setSocialLoading] = useState<null | "google" | "apple">(
    null
  );
  const [socialError, setSocialError] = useState("");
  const [skipVerification, setSkipVerification] = useState(false);
  const [isMac, setIsMac] = useState(false);
  //captcha state
  // const [captchaImage, setCaptchaImage] = useState("");
  // const [captchaAnswer, setCaptchaAnswer] = useState();

  const {
    register,
    handleSubmit,
    formState: { errors },
    watch,
    setError,
    reset,
    control,
  } = useForm<Inputs>();

  // Watch the field for verify process
  const password = useRef({});
  password.current = watch("password", "");
  const currentEmail = useRef({});
  currentEmail.current = watch("email", "");
  const referId = query.get("refer") || null;
  // const phone = watch("contact_info");111
  // Mount component
  useEffect(() => {
    if (referId) {
      fetchReferEmail();
    }
  }, []);

  // useEffect(() => {
  //   if (path === '/sign-up') {
  //     createCaptcha();
  //   }
  // }, [path])

  useEffect(() => {
    const platform = navigator.platform.toLowerCase();
    if (platform.includes("mac")) {
      setIsMac(true);
    }
  }, []);

  const handleSocialLogin = async (providerKey: "google" | "apple") => {
    setSocialError("");
    setSocialLoading(providerKey);

    try {
      let result;
      const auth = getAuth();
      if (providerKey === "google") {
        const provider = new GoogleAuthProvider();
        provider.setCustomParameters({ prompt: "select_account" });
        result = await signInWithPopup(auth, provider);
      } else {
        const provider = new OAuthProvider("apple.com");
        result = await signInWithPopup(auth, provider);
      }

      const idToken = await result.user.getIdToken();
      const resp = await httpRequest().post(API_URLS.socialLogin, { idToken });
      setSkipVerification(true);
      // Handle success: Dispatch the user login success action
      dispatch(
        userSignUpSuccess({
          messages: resp.data.message,
          data: resp.data.data,
        })
      );

      const token = _.get(resp, "data.data.token", "");
      const sessionData = _.get(
        resp,
        "data.data.session",
        _.get(resp, "data.data", {})
      );
      if (token) {
        dispatch(setSessionTokenRequest(token));
      }
      if (sessionData && Object.keys(sessionData).length > 0) {
        dispatch(setSessionUserRequest(sessionData));
        // If session contains companies, set current company if applicable
        const companyDetails =
          (sessionData.companies || []).find((c: any) => c.privileges) ||
          (sessionData.companies || [])[0] ||
          null;
        if (companyDetails) {
          dispatch(setCurrentCompanyRequest(companyDetails));
        }
      }

      navigate(appRoutes.candidateProfileView.path);
    } catch (err: unknown) {
      setSocialError(socialLoginErrorMessage(err));
    } finally {
      setSocialLoading(null); // Reset loading state after the process is complete
    }
  };

  const fetchReferEmail = async () => {
    try {
      const { data } = await httpRequest().post<{
        data: string;
      }>(API_URLS.fetchReferFriendEmail, { referId });

      const referEmail = data?.data || "";
      if (referEmail) {
        setDisabledReferEmail(true);
        reset({
          email: referEmail,
          verify_email: referEmail,
        });
      }
    } catch (error) {
      //
    }
  };
  console.log(signUpFlag, "signUpFlagsignUpFlag");
  // Sign up success Hook
  useEffect(() => {
    if (signUpFlag === true) {
      reset();
      dispatch(userSignUpReset());
      // navigate(appRoutes.userVerify.generatePath(emailToken));
      if (skipVerification) {
        navigate(appRoutes.candidateProfileView.path);
        // reset the flag so future signups behave normally
        setSkipVerification(false);
      } else {
        navigate(appRoutes.userVerify.generatePath(emailToken), {
          state: { email: String(currentEmail.current || "").trim() },
        });
      }
    } else if (signUpFlag === false) {
      dispatch(userSignUpReset());
      _.forEach(signUpErrors, (value, key: any) => {
        setError(key, { type: "manual", message: value });
      });

      if (signUpErrorMessage) {
        setSignUpError(signUpErrorMessage);
      }
    }
  }, [signUpFlag, skipVerification]);

  const onSubmit = async (formData) => {
    // const captcha = formData.captcha_answer
    // if (captcha === captchaAnswer) {

    let payload = {
      first_name: formData.first_name || "",
      last_name: formData.last_name || "",
      email: currentEmail.current || "",
      password: formData.password || "",
      confirm_password: formData.confirm_password || "",
      gender: genderVal,
      // token: captcha,
      action: "sign_up",
      refer: referId,
      contact_info: formData.contact_info || "",
    };

    if (genderVal === "custom") {
      payload["gender_pronoun"] = _.get(formData, "gender_pronoun.value", 0);
      payload["gender_optional"] = formData.gender_optional || "";
    }
    if (signUpState === "company") {
      delete (payload as any)["gender"];
      payload["employee_id"] = formData.employee_id;
      payload["company_name"] = formData.company_name.value;

      dispatch(companySignUpRequest(payload));
    } else {
      dispatch(userSignUpRequest(payload));
    }

    // } else {
    //   FlashMessage("Please Enter Valid Captcha", "error")
    // }
  };

  const updateSignUpState = (type: "company" | "employer"): void => {
    setSignUpState(type);
  };

  const searchCompanies = (search: string) =>
    new Promise((resolve) => {
      clearTimeout(searchDelay);
      searchDelay = setTimeout(async () => {
        const companiesData = await companyServices.searchCompanyByName(search);

        const companies = _.get(companiesData, "data", []).map((c: any) => ({
          value: c?.id,
          label: c?.company_name,
        }));

        resolve(companies);
      }, 1000);
    });

  // const createCaptcha = async () => {
  //   const data = await httpRequest().post(API_URLS.captcha);
  //   const svgImage = data.data.data.data
  //   const responseCaptchaAnswer = data.data.data.text
  //   setCaptchaAnswer(responseCaptchaAnswer)
  //   setCaptchaImage(svgImage)
  // }

  return (
    <>
      <div className="left-part">
        <Affirmation />
      </div>
      <div className="right-part">
        <div className="">
          <div className="back-website">
            <div className="back">
              <Link to={appRoutes.home.path}>
                {" "}
                <ArrowBackIosIcon />{" "}
              </Link>
            </div>
            <Link to={appRoutes.home.path}>Back to website</Link>
          </div>
          <div className="auth-card auth-signup-wrapper">
            <h2 className="auth-card-title">Create an account</h2>

            <p className="outer-link sign-up-outer-link">
              {signUpState === "employer" ? (
                <div>
                  Are you an Employer?{" "}
                  <span
                    className="span-link"
                    onClick={() => updateSignUpState("company")}
                  >
                    Click Here
                  </span>
                </div>
              ) : (
                <div>
                  Are you a Candidate?{" "}
                  <span
                    className="span-link"
                    onClick={() => updateSignUpState("employer")}
                  >
                    Click Here
                  </span>
                </div>
              )}
            </p>

            <br />
            <form onSubmit={handleSubmit(onSubmit)}>
              <div className="form-group">
                <label className="form-group-label required">Full Name</label>
                <div className="inline-inputs">
                  <Input
                    // name="first_name"
                    placeholder="First Name"
                    validationObj={errors}
                    autoFocus
                    icon={<PersonIcon />}
                    {...register("first_name", {
                      required: {
                        value: true,
                        message: "Please enter first name",
                      },
                    })}
                  />
                  <Input
                    // name="last_name"
                    placeholder="Last Name"
                    validationObj={errors}
                    icon={<PersonIcon />}
                    {...register("last_name", {
                      required: {
                        value: true,
                        message: "Please enter last name",
                      },
                    })}
                  />
                </div>
              </div>

              <div className="phone-email-wrapper">
                <div className="form-group">
                  <label className="form-group-label required">Email Address</label>
                  <div className="inline-inputs email-input">
                    <Input
                      // name="email"
                      disabled={disabledReferEmail}
                      placeholder="Email"
                      validationObj={errors}
                      icon={<EnvelopeIcon />}
                      {...register("email", {
                        required: {
                          value: true,
                          message: "Please enter email address",
                        },
                        pattern: {
                          value: /\S+@\S+\.\S+/,
                          message: "Enter valid email address",
                        },
                      })}
                    />

                    {/* <Input
                    name="verify_email"
                    disabled={disabledReferEmail}
                    placeholder="Re-enter Email"
                    validationObj={errors}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <EnvelopeIcon />
                        </InputAdornment>
                      ),
                    }}
                    inputRef={register({
                      required: {
                        value: true,
                        message: "Please enter verify email address",
                      },
                      pattern: {
                        value: /\S+@\S+\.\S+/,
                        message: "Enter valid verify email address",
                      },
                      validate: (value) =>
                        value === currentEmail.current ||
                        "The verify email do not match",
                    })}
                  /> */}
                  </div>
                </div>

                <div className="form-group">
                  <label className="form-group-label required">Phone Number</label>
                  <div
                    className={`${
                      errors.contact_info && "error"
                    } sign-up-phone`}
                  >
                    <EditableText
                      inputClassName="editable-input"
                      control={control}
                      autoFocus={false}
                      name="contact_info"
                      country="us"
                      placeholder="Phone Number"
                      icon={<img src={PhoneIcon} alt="" />}
                      error={errors.contact_info}
                      rules={{
                        validate: validatePhoneNumber,
                      }}
                    />
                  </div>
                </div>
              </div>
              <div className="form-group">
                <label className="form-group-label required">Password</label>
                <div className="inline-inputs">
                  <Input
                    type="password"
                    // name="password"
                    placeholder="Password"
                    validationObj={errors}
                    icon={<LockIcon />}
                    {...register("password", {
                      required: {
                        value: true,
                        message: "Please enter password",
                      },
                      minLength: {
                        value: 4,
                        message: "Password must be between 4 to 16 characters",
                      },
                      maxLength: {
                        value: 16,
                        message: "Password must be between 4 to 16 characters",
                      },
                      pattern: {
                        value:
                          /^(?=.*[a-z])(?!.* )(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])/,
                        message:
                          "Must content at least one upper case, lower case, digit, special character and no white space",
                      },
                    })}
                  />
                  <Input
                    type="password"
                    // name="confirm_password"
                    placeholder="Re-enter Password"
                    validationObj={errors}
                    icon={<LockIcon />}
                    {...register("confirm_password", {
                      required: {
                        value: true,
                        message: "Please enter  password",
                      },
                      validate: (value) =>
                        value === password.current ||
                        "The re-entered do not match",
                    })}
                  />
                </div>
              </div>
              {signUpState === "company" ? (
                <div className="form-group company-inputs">
                  <label className="form-group-label required">Company Name</label>
                  <div className="inline-inputs">
                    <AsyncCreatableSelect
                      control={control}
                      validationObj={errors}
                      placeholder="Search Company..."
                      name="company_name"
                      icon={<CompanyIcon />}
                      onStartSearching={searchCompanies}
                      noOptionsMessage="No matching company found"
                      rules={{
                        required: {
                          value: true,
                          message: "Please select company",
                        },
                      }}
                    />
                    <Input
                      // name="employee_id"
                      placeholder="Enter Employee ID"
                      validationObj={errors}
                      icon={<PersonIcon />}
                      {...register("employee_id", {
                        required: {
                          value: true,
                          message: "Please enter employee ID",
                        },
                      })}
                    />
                  </div>
                </div>
              ) : (
                <>
                  <div className="form-group gender-group">
                    <label className="form-group-label required">Gender</label>
                    <Radio
                      name="gender"
                      control={control}
                      wrapperClassName="gender-radio-wrapper w-100"
                      labelClassName="gender-radio"
                      validationObj={errors}
                      onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                        const selected = e.target.value;
                        setGenderVal(selected); // for custom pronoun display
                      }}
                      options={[
                        { label: "Female", value: "female" },
                        { label: "They", value: "they" },
                        { label: "Custom", value: "custom" },
                      ]}
                      rules={{
                        required: {
                          value: true,
                          message: "Please select gender",
                        },
                      }}
                    />
                  </div>
                  <div className="form-group pronoun-fields">
                    {genderVal === "custom" && (
                      <>
                        <div className="inline-inputs">
                          <div className="select-wrapper">
                            <SelectNew
                              name="gender_pronoun"
                              placeholder="Select your pronoun"
                              className="select-box"
                              options={CUSTOM_GENDER_OPTIONS}
                              isSearchable={false}
                              validationObj={errors}
                              control={control}
                              rules={{
                                required: {
                                  value: true,
                                  message: "Please select your pronoun",
                                },
                              }}
                            />
                          </div>
                          <Input
                            // name="gender_optional"
                            placeholder="Customize your pronoun"
                            className="geneder-field"
                            validationObj={errors}
                            {...register("gender_optional", {
                              required: {
                                value: true,
                                message: "Customize your pronoun",
                              },
                              maxLength: {
                                value: 15,
                                message: "Can't exceed more then 15 Character",
                              },
                            })}
                          />
                        </div>
                      </>
                    )}
                  </div>
                </>
              )}
              {/* <div className="form-group captcha-view">
                <div dangerouslySetInnerHTML={{
                  __html: captchaImage,
                }} />

                <Input
                  name="captcha_answer"
                  placeholder="Enter Captcha Answer"
                  validationObj={errors}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <AutoModeIcon className="captcha-icon" onClick={() => createCaptcha()} />
                      </InputAdornment>
                    ),
                  }}
                  inputRef={register({
                    required: {
                      value: true,
                      message: "Please enter captcha answer",
                    },
                    pattern: {
                      value: /[0-9]+/,
                      message: "Enter valid captcha answer",
                    },
                    validate: (value) =>
                      value === captchaAnswer ||
                      "The verify captcha do not match",
                  })}
                />
              </div> */}
              <div className="form-group">
                <div className="inline-inputs check">
                  <label
                    htmlFor="privacyAgreement"
                    className="privacy-agreement"
                  >
                    By signing up, I agree to employ<span>HER</span>’s{" "}
                    <a
                      rel="noreferrer"
                      target="_blank"
                      href={appRoutes.termsOfService.generatePath()}
                    >
                      Terms of Service
                    </a>
                    .
                  </label>
                  {errors.termsAndConditions && (
                    <FormHelperText className="text-danger">
                      {errors.termsAndConditions.message}
                    </FormHelperText>
                  )}
                </div>
              </div>
              {signUpError.length > 0 && (
                <p className="text-center mb-2">
                  <MessageHelper type="error" text={signUpError} />
                </p>
              )}
              <div className="form-group btn-group">
                <Button type="submit" color="primary" loading={loading}>
                  Create account
                </Button>
              </div>
            </form>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 12,
                margin: "16px 0",
                fontWeight: 500,
              }}
            >
              <span style={{ flex: 1, height: 2, background: "#eee" }} />
              <span style={{ fontSize: "var(--fs-body2)", color: "#999" }}>
                Or Continue With
              </span>
              <span style={{ flex: 1, height: 2, background: "#eee" }} />
            </div>

            <div className="social-login d-flex justify-content-center ">
              <Button
                onClick={() => handleSocialLogin("google")}
                loading={socialLoading === "google"}
                variant="outlined"
                color="social"
              >
                <GoogleSVG />
                &nbsp;Google
              </Button>
              {isMac && (
                <Button
                  onClick={() => handleSocialLogin("apple")}
                  loading={socialLoading === "apple"}
                  variant="outlined"
                  color="social"
                >
                  <Apple style={{ color: "#000" }} />
                  &nbsp;Apple
                </Button>
              )}
            </div>
            {socialError && (
              <div className="mt-2 text-center">
                <span className="text-sm text-danger error-helper">
                  {socialError}
                </span>
              </div>
            )}

            {/* <div className="social-login-wrapper">
          <div className="label-wrapper">
            <p>Or sign up with</p>
          </div>
          <div className="icons">
            <div>
              <Image src={GoogleIcon} alt="social-icon-google" />
            </div>
            <div>
              <Image src={FacebookIcon} alt="social-icon-facebook" />
            </div>
          </div>
        </div> */}
          </div>
          <p className="outer-link sign-up-outer-link">
            Already have an account?{" "}
            <Link to={appRoutes.userLogin.path}>Sign in</Link>
          </p>
        </div>
      </div>
    </>
  );
};

export default SignUp;
